import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      // Show all pages if total is 5 or less
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        // Show first 4 pages and ellipsis to last
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        // Show first page, ellipsis, and last 4 pages
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        // Middle range with ellipsis on one side only (choose one side)
        pages.push(1, "...", currentPage, currentPage + 1, currentPage + 2);
        if (currentPage + 2 < totalPages) pages.push("...", totalPages);
      }
    }

    // Remove duplicates and ensure only one "..." appears
    const result = [];
    let ellipsisAdded = false;
    for (let i = 0; i < pages.length; i++) {
      if (pages[i] === "...") {
        if (!ellipsisAdded) {
          result.push("...");
          ellipsisAdded = true;
        }
      } else {
        result.push(pages[i]);
      }
    }

    return result;
  };

  const renderPageItem = (page, index) => {
    if (page === "...") {
      return (
        <li key={`ellipsis-${index}`} className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    return (
      <li
        key={page}
        className={`page-item ${page === currentPage ? "active" : ""}`}
      >
        <button className="page-link" onClick={() => onPageChange(page)}>
          {page}
        </button>
      </li>
    );
  };

  const pageNumbers = getPageNumbers();

  return (
    <nav>
      <ul className="pagination">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &laquo;
          </button>
        </li>

        {pageNumbers.map((page, index) => renderPageItem(page, index))}

        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            &raquo;
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
